<template>
  <div id="app" v-bind:class="{'is-mida': $isMida}">
    <keep-alive>
      <component :is="layout">
        <router-view :key="$route.path" />
      </component>
    </keep-alive>
  </div>
</template>

<script>
const defaultLayout = 'unauth'

/*
:root {
  --primary: rgba(51, 65, 85, 1);
  --sidebar-width: 260px;
  --dd-x: 0;
  --dd-y: 0;
  --body-background: #090c10;
  --background: #1f2226;
  --background-muted: 64, 64, 64;
  --color: #fff;
  --table-hover: #0d111740;
  --color-muted: #dbeaff;
  --color-muted-hover: #f6faff;
  --side-color: #c7d6e6;
  --background-header: #090c10;
  --invert-color: 1;
  --background-table-header: #f7fafc;
}
*/

export default {
  name: 'App',
  beforeCreate() {
    ;(async () => {
      await this.$initDomain()
    })()
    localStorage.setItem('theme', 'light')
    if (localStorage.getItem('theme') === 'dark') {
      document.body.style.setProperty('--primary', 'rgba(51, 65, 85, 1)')
      document.body.style.setProperty('--sidebar-width', '240px')
      document.body.style.setProperty('--dd-x', '0')
      document.body.style.setProperty('--dd-y', '0')
      document.body.style.setProperty('--body-background', '#090c10')
      document.body.style.setProperty('--background', '#1f2226')
      document.body.style.setProperty('--background-muted', '64, 64, 64')
      document.body.style.setProperty('--background-light', '#404040')
      document.body.style.setProperty('--color', '#fff')
      document.body.style.setProperty('--table-hover', '#0d111740')
      document.body.style.setProperty('--color-muted', '#dbeaff')
      document.body.style.setProperty('--color-muted-hover', '#f6faff')
      document.body.style.setProperty('--side-color', '#c7d6e6')
      document.body.style.setProperty('--background-header', '#090c10')
      document.body.style.setProperty('--invert-color', '1')
      document.body.style.setProperty('--background-table-header', '#444')
      document.body.style.setProperty('--color-muted-darker', '#dbeaff')
    }

    if (this.$isMida) {
      // document.body.style.setProperty('--background-table-header', '#efefef')
      document.body.style.setProperty('--background-table-header', 'transparent')
    }

    if (window.location.host === 'optimize.howuku.com') window.location.href = 'https://app.mida.so/'
  },
  created() {
    if (this.$session.get('language')) {
      this.$initTranslation().then(() => {
        this.$translate.setLang(this.$session.get('language'))
      })
    }
    this.checkTimeout()
    setInterval(() => {
      this.checkTimeout()
    }, 60000)
    
    if (window.location.host.includes('.howuku.com') && !window.location.href.includes('survey.howuku.com') && !window.location.href.includes('/link/')) {
      (function(t,r,a,c,k){
        c=['track','identify','converted'],t.o=t._init||{},
        c.map(function(n){return t.o[n]=t.o[n]||function(){(t.o[n].q=t.o[n].q||[]).push(arguments);};}),t._init=t.o,
        k=r.createElement("script"),k.type="text/javascript",k.async=true,k.src="https://cdn.howuku.com/js/track.js",k.setAttribute("key",a),
        r.getElementsByTagName("head")[0].appendChild(k);
      })(window, document, "k3Ejq4KNndxpdJyArpv7bX");
    }

    if (window.location.host.includes('.mida.so')) {
      let scriptTag = document.createElement('script');
      scriptTag.type = 'text/javascript';
      scriptTag.src = 'https://cdn.mida.so/js/optimize_experiment.js?key=1Avp2DgnY6EZ0dXJbK9koW&v=saidz';
      document.head.appendChild(scriptTag);

      let scriptTag2 = document.createElement('script');
      scriptTag2.type = 'text/javascript';
      scriptTag2.defer = true;
      scriptTag2.setAttribute('data-domain', 'mida.so');
      scriptTag2.src = 'https://plausible.io/js/script.manual.js';
      document.head.appendChild(scriptTag2);

      window.plausible = window.plausible || function() { (window.plausible.q = window.plausible.q || []).push(arguments) }


      (function(w){w.fpr=w.fpr||function(){w.fpr.q = w.fpr.q||[];w.fpr.q[arguments[0]=='set'?'unshift':'push'](arguments);};})(window);
      fpr("init", {cid:"aee9h5l9"}); 

      let fprScript = document.createElement('script');
      fprScript.type = 'text/javascript';
      fprScript.async = true;
      fprScript.src = 'https://cdn.firstpromoter.com/fpr.js';
      document.head.appendChild(fprScript);

      (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
      })(window, document, "clarity", "script", "jsd59c72vi");
    }
  },
  computed: {
    layout() {
      return (this.$route.meta.layout || defaultLayout) + '-layout'
    },
  },
  methods: {
    checkTimeout: function () {
      let timeAgo = new Date()
      timeAgo.setHours(timeAgo.getHours() - 72)

      if (
        this.$session.exists('email') &&
        (!this.$session.exists('session_time') ||
          this.$session.get('session_time') < +timeAgo)
      ) {
        this.$session.destroy()
        this.$router.push({ path: '/' })
      }
    },
  },
  data: function () {
    return {
      auth: false,
    }
  },
}
</script>

<style>
/* dark theme */

/* white theme */
:root {
  --primary: rgba(51, 65, 85, 1);
  --sidebar-width: 240px;
  --dd-x: 0;
  --dd-y: 0;
  --body-background: #eef2f6;
  --background: #fff;
  
  --background-muted: 244,244,244;
  /* --background-muted: 239, 239, 239; */

  /* --background-light: #e8f1f7; */
  --background-light: #ebedf2;
  
  --color: #2a2a2a; /*#082950;*/
  --table-hover: #eaf3ff40;
  --color-muted: rgba(100, 116, 139, 1);
  --color-muted-hover: #5c5c5c;
  --side-color: #586069;
  --background-header: #eef2f6;
  --invert-color: 0;
  --background-table-header: #f7fafc;
  --color-muted-darker: #616770;
}

body {
  overflow: auto;
  overflow-x: hidden;
  /* background-color: rgb(237, 242, 247); */
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--color);
}

tbody {
  background-color: var(--background);
}

@font-face {
  font-family: 'AppleGaramond-Bold';
  src: url('../static/assets/AppleGaramond-Bold.ttf') format('truetype');
}
@font-face {
  font-family: 'AppleGaramond';
  src: url('../static/assets/AppleGaramond.ttf') format('truetype');
}

.box-title {
  font-family: 'Inter var', system-ui, -apple-system, BlinkMacSystemFont,
    'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif,
    'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji';
}

.logo {
  font-family: 'AppleGaramond-Bold';
  color: #2c3e50 !important;
}

.swal2-container {
  z-index: 99999 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue